import React, { useState } from "react";
import NewGP from "./NewGP";
import UpdateGP from "./UpdateGP";

const GPComponent = ({ item, onSubmit, title = "GP Information" }) => {
    const [newItem, setNewItem] = useState(false);

    return (
        <div className="card">
            <div className="card-head">
                <header>{title}</header>
                <div className="tools">
                    <a className="t-collapse btn-color fa fa-chevron-down" href="javascript:;"></a>
                </div>
            </div>
            <div className="card-body">
                {item && !newItem && (
                    <>
                        <table className="table table-bordered">
                            <tbody>
                                <tr>
                                    <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                        <strong>Name</strong>
                                    </td>
                                    <td>{item.name}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                        <strong>Phone</strong>
                                    </td>
                                    <td>{item.mobile}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                        <strong>Email</strong>
                                    </td>
                                    <td>{item.email}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                        <strong>Post Code</strong>
                                    </td>
                                    <td>{item.post_code}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                        <strong>Contact Address</strong>
                                    </td>
                                    <td>{item.address}</td>
                                </tr>
                            </tbody>
                        </table>

                        <div>
                            <button
                                onClick={() => {
                                    setNewItem(true);
                                }}
                                type="type"
                                className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle btn-success"
                            >
                                Update GP
                            </button>
                        </div>
                    </>
                )}
                {!item && !newItem && (
                    <>
                        <h4 className="text-info">GP record has not been added yet!</h4>

                        <center>
                            <button
                                onClick={() => {
                                    setNewItem(true);
                                    // setActive(item.nextOfKin);
                                }}
                                type="type"
                                className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-bottom-10 btn-circle btn-success"
                            >
                                Add GP
                            </button>
                        </center>
                    </>
                )}

                {!item && newItem && (
                    <div className="fade-in">
                        <NewGP
                            onSubmit={item => {
                                onSubmit(item);
                                setNewItem(false);
                            }}
                            onCancel={() => {
                                setNewItem(false);
                            }}
                        />
                    </div>
                )}
                {item && newItem && (
                    <div className="fade-in">
                        <UpdateGP
                            onSubmit={item => {
                                onSubmit(item);
                                setNewItem(false);
                            }}
                            onCancel={() => {
                                setNewItem(false);
                            }}
                            item={item}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
export default GPComponent;
